import React from "react";
import "./Fourth.css";
import { Container } from "react-bootstrap";
import health from "../../../../Asset/mobileApp/healthcare.svg";
import ecom from "../../../../Asset/mobileApp/ecommerce.svg";
import enter from "../../../../Asset/mobileApp/entertainment.svg";
import edu from "../../../../Asset/mobileApp/education.svg";
import logi from "../../../../Asset/mobileApp/logistic.svg";
import travels from "../../../../Asset/mobileApp/travels.svg";
import fintech from "../../../../Asset/mobileApp/fintech.svg";
import restaurant from "../../../../Asset/mobileApp/restaurant.svg";

const industries = [
  { imgSrc: health, title: "Health & Fitness" },
  { imgSrc: ecom, title: "E-commerce" },
  { imgSrc: enter, title: "Entertainment" },
  { imgSrc: edu, title: "Education" },
  { imgSrc: logi, title: "Logistics" },
  { imgSrc: travels, title: "Tour & Travels" },
  { imgSrc: fintech, title: "Fintech" },
  { imgSrc: restaurant, title: "Restaurant" },
];

const Fourth = () => {
  return (
    <section className="fourth-mobileapp-section">
      <Container>
        <div className="top-text-after-fourth-services">
          <h2>
            INDUSTRIES WE ARE <span>DELIGHTED TO SERVE</span>
          </h2>
        </div>
        <div className="row">
          {industries.map((industry, index) => (
            <div key={index} className="col-xl-3 col-md-4 col-sm-6">
              <div>
                <div className="card service-section-4-card">
                  <img src={industry.imgSrc} alt={industry.title} />
                  <h5>{industry.title}</h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Fourth;
